import { useTheme } from "@/context/ThemeContext";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  const { theme } = useTheme();

  return (
    <footer data-testid={FOOTER.footer} className="py-12" style={{ borderTop: "1px solid var(--sv-border)" }}>
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          <div>
            <img
              src={theme === "light" ? "/siveli-mark-transparent.png" : "/siveli-logo-dark.png"}
              alt="Siveli Consulting"
              className="h-10 w-auto object-contain"
            />
          </div>
          <div className="flex flex-wrap gap-8 text-sm text-themed-muted">
            <a href="#services" className="gold-underline hover:text-themed-gold transition-colors">Services</a>
            <a href="#metrics" className="gold-underline hover:text-themed-gold transition-colors">Results</a>
            <a href="#resources" className="gold-underline hover:text-themed-gold transition-colors">Resources</a>
            <a href="#contact" className="gold-underline hover:text-themed-gold transition-colors">Contact</a>
          </div>
        </div>
        <div className="section-divider mt-8 mb-6" />
        <p data-testid={FOOTER.copyright} className="text-xs text-themed-muted" style={{ fontFamily: "var(--sv-mono-font)" }}>
          &copy; {new Date().getFullYear()} Siveli Consulting. All rights reserved. Engineering High Velocity People Function.
        </p>
      </div>
    </footer>
  );
}
